let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("helYz")).then(() => parcelRequire('9N5CX'));